export enum PaymentMethodCode {
  APM = "payment_services_paypal_apm",
  APPLE_PAY = 'payment_services_paypal_apple_pay',
  CREDIT_CARD = 'payment_services_paypal_hosted_fields',
  FASTLANE = 'payment_services_paypal_fastlane',
  GOOGLE_PAY = 'payment_services_paypal_google_pay',
  SMART_BUTTONS = 'payment_services_paypal_smart_buttons',
  VAULT = 'payment_services_paypal_vault',
}
